module.exports = __webpack_public_path__ + "static/media/(000060).902b1fe4.jpg";